import { Box } from "@mui/material";
import React, { useState } from "react";
import AddAccont from "../../assets/SVG/addAccont";
import DashboardIcon from "../../assets/SVG/dashboard";
import DrugIcon from "../../assets/SVG/drugIcon";
import FlagIcon from "../../assets/SVG/flagIcon";
import ReportIcon from "../../assets/SVG/reportIcon";
import SettingIcon from "../../assets/SVG/settingIcon";
import SupportIcon from "../../assets/SVG/supportIcon";
import UserCheckIcon from "../../assets/SVG/userCheckIcon";
import { OptionsSidebar } from "./sidebar";

export default function SidebarGroup() {
  const [select, setSelect] = useState(0);
  // console.log(window.location.pathname);
  return (
    <>
      <Box>
        <OptionsSidebar
          href="/"
          onClick={() => setSelect(0)}
          select={window.location.pathname === "/" ? false : true}
          text="داشبورد"
          icon={
            <DashboardIcon
              color={
                window.location.pathname === "/"
                  ? "white"
                  : "var(--emr-disable)"
              }
            />
          }
        />
        <OptionsSidebar
          href="/trips"
          onClick={() => setSelect(1)}
          select={window.location.pathname === "/trips" ? false : true}
          text="اردو ها"
          icon={
            <FlagIcon
              color={
                window.location.pathname === "/trips"
                  ? "white"
                  : "var(--emr-disable)"
              }
            />
          }
        />
        <OptionsSidebar
          href="/acconts_trip"
          onClick={() => setSelect(3)}
          select={window.location.pathname === "/acconts_trip" ? false : true}
          text="ثبت‌نام کنندگان"
          icon={
            <AddAccont
              color={
                window.location.pathname === "/acconts_trip"
                  ? "white"
                  : "var(--emr-disable)"
              }
            />
          }
        />
        <OptionsSidebar
          href="/reports"
          onClick={() => setSelect(4)}
          select={window.location.pathname === "/reports" ? false : true}
          text="گزارشات"
          icon={
            <ReportIcon
              color={
                window.location.pathname === "/reports"
                  ? "white"
                  : "var(--emr-disable)"
              }
            />
          }
        />
        <OptionsSidebar
          href="/drug"
          onClick={() => setSelect(5)}
          select={window.location.pathname === "/drug" ? false : true}
          text="انبار داروخانه"
          icon={
            <DrugIcon
              color={
                window.location.pathname === "/drug"
                  ? "white"
                  : "var(--emr-disable)"
              }
            />
          }
        />
        <OptionsSidebar
          href="/equipment"
          onClick={() => setSelect(6)}
          select={window.location.pathname === "/equipment" ? false : true}
          text="انبار تجهیزات"
          icon={
            <DrugIcon
              color={
                window.location.pathname === "/equipment"
                  ? "white"
                  : "var(--emr-disable)"
              }
            />
          }
        />
        <OptionsSidebar
          href="/erja"
          onClick={() => setSelect(7)}
          select={window.location.pathname === "/erja" ? false : true}
          text="مسئول ارجاع"
          icon={
            <UserCheckIcon
              color={
                window.location.pathname === "/erja"
                  ? "white"
                  : "var(--emr-disable)"
              }
            />
          }
        />
      </Box>
    </>
  );
}
